<div class="container">
	<div class="page-titel">
		<div class="titel">
			<app-pasfoto size="size-3-5" [pasfotoKey]="afkorting()"></app-pasfoto>
			<div class="titel-tekst">
				<h1 class="begroeting">{{ begroeting() }} {{ userService.begroetingsnaam() }},</h1>
				<span class="subtitel">{{ subtitel() }}</span>
			</div>
		</div>
		@if (!navigatieVoorkeurService.nieuweNavigatie() && rollen().length >= 2) {
			<app-rol-switcher [rollen]="rollen()" [activeRol]="activeRol()" (rolChange)="changeRol($event)"></app-rol-switcher>
		}
	</div>
	<app-ai-assistent></app-ai-assistent>
	<app-recent-bekeken></app-recent-bekeken>
	<div class="panelen">
		<div class="paneel">
			<app-favorieten-list></app-favorieten-list>
		</div>
		<app-berichten></app-berichten>
	</div>
</div>
